import { createSelectorPathBuilder } from '@/checkout-instore-legacy/utils/selectorHelper'

export const nativeSelector = createSelectorPathBuilder([
  (state: any): any => state?.native,
])

export const appVersionSelector = createSelectorPathBuilder([
  nativeSelector,
  (native: any): any => native?.appVersion,
])

export const nativeAppInfoSelector = createSelectorPathBuilder([
  nativeSelector,
  (native: any): any => native?.nativeAppInfoSelector,
])

export const deviceSelector = createSelectorPathBuilder([
  nativeAppInfoSelector,
  (nativeAppInfo: any): any => nativeAppInfo?.device,
])
